import React, { useState, useEffect, useCallback } from "react";
import { FaCalendarCheck, FaTimes } from "react-icons/fa";
import {
  NotificationWrapper,
  NotificationHeader,
  NotificationContent,
} from "./AppointmentNotificationStyles";

const AppointmentNotification = ({ appointment, onClose }) => {
  const [show, setShow] = useState(false);
  const { user, status, date, topic } = appointment;

  // Animate the notification in
  useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Auto dismiss after a period
  const handleClose = useCallback(() => {
    setShow(false);

    // Give time for exit animation before removing from DOM
    setTimeout(() => {
      if (onClose) onClose();
    }, 300);
  }, [onClose]);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        handleClose();
      }, 6000); // Auto dismiss after 6 seconds

      return () => clearTimeout(timer);
    }
  }, [show, handleClose]);

  // Format date to a more readable form
  const formatDate = (dateString) => {
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  return (
    <NotificationWrapper show={show}>
      <NotificationHeader>
        <h4>
          <FaCalendarCheck />
          Upcoming Appointment
        </h4>
        <button onClick={handleClose}>
          <FaTimes />
        </button>
      </NotificationHeader>
      <NotificationContent>
        <p>
          You have a <span className="highlight">{status}</span> appointment
          with <span className="highlight">{user.name}</span>.
        </p>
        <div className="appointment-details">
          <p className="appointment-time">{formatDate(date)}</p>
          <p>Topic: {topic}</p>
        </div>
      </NotificationContent>
    </NotificationWrapper>
  );
};

export default AppointmentNotification;
